import { type WidgetData } from "@repo/api";

import { getNewCoordinates } from "./customize/reposition";

export type GridWidget = WidgetData & { gridCol: string; gridRow: string };

const getSpan = (curr: number, span?: number) => {
  if (span === 1) {
    return `${curr + 1}`;
  }

  return `${curr + 1} / span ${span}`;
};

export function convertFromOldWidgetPosToNew(data: WidgetData[] | undefined) {
  if (data === undefined) {
    return;
  }

  if (!data.some((w) => w.widgetSettings.appPos !== undefined)) {
    return;
  }

  const sortedWidgets = data.sort(
    (a: WidgetData, b: WidgetData) =>
      (a.widgetSettings.appPos ?? 0) - (b.widgetSettings.appPos ?? 0)
  );

  for (const w of sortedWidgets) {
    const cc = getNewCoordinates(sortedWidgets, w.widgetSettings.appSize);

    w.widgetSettings.top = cc.top;
    w.widgetSettings.left = cc.left;
    w.widgetSettings.appPos = undefined;
  }

  return sortedWidgets;
}

export function calculateWidgetGrid(widgets: WidgetData[]) {
  const grid = [];

  widgets.sort((a, b) => {
    if (a.widgetSettings.top === b.widgetSettings.top) {
      return a.widgetSettings.left - b.widgetSettings.left;
    }
    return a.widgetSettings.top - b.widgetSettings.top;
  });

  for (const widget of widgets) {
    grid.push({
      ...widget,
      gridCol: getSpan(
        widget.widgetSettings.left,
        widget.widgetSettings.appSize.col
      ),
      gridRow: getSpan(
        widget.widgetSettings.top,
        widget.widgetSettings.appSize.row
      ),
    });
  }

  return grid;
}
